/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DisplayHtmlContent, NeedToKnow as NeedToKnowSarsaparilla } from 'sarsaparilla';
import { ContentProps } from '../props/contents';
import NoFeePeriods from './parkPasses/NoFeePeriods';

/**
 * NOTE: This component is used by ui-widget. We will need to check ui-widget whenever we do a change here
 */
export default class NeedToKnow extends PureComponent {
    static defaultProps = {
        checked: false,
        className: '',
        onChange: () => {},
        siteName: 'our site',
        siteDomain: process.env.SITE_NAME,
        needToKnow: [],
        showCheckbox: true,
        noFeePeriods: [],
    };

    static propTypes = {
        className: PropTypes.string,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        needToKnow: PropTypes.arrayOf(ContentProps),
        noFeePeriods: PropTypes.arrayOf(PropTypes.object),
        showCheckbox: PropTypes.bool,
        siteName: PropTypes.string,
        siteDomain: PropTypes.string,
    };

    informationRef = React.createRef();

    componentDidMount() {
        const ref = this.informationRef.current;
        if (ref && ref.scrollHeight - ref.clientHeight <= 0) {
            ref.parentElement.classList = `${ref.parentElement.classList} no-scrollable-content`;
        }
    }

    render() {
        const {
            checked,
            className,
            showCheckbox,
            onChange,
            siteName,
            noFeePeriods,
            needToKnow,
            siteDomain,
        } = this.props;
        const introText = `Please carefully review the important information below ${
            showCheckbox
                ? 'and click the check box to agree to the rules and regulations'
                : ''
        }. The information in this section only pertains to this pass. Other important visitation policies and details can be found on the ${siteDomain} page for ${
            siteName
        }.`;

        return (
            <NeedToKnowSarsaparilla
                introText={introText}
                className={className}
                isChecked={checked}
                showCheckbox={showCheckbox}
                onChange={() => onChange(!checked)}
            >
                {needToKnow.map(({ title, paragraphs = [] }, i) => (
                    <section className="rec-order-detail-need-help" key={`section-${i}`}>
                        {!!title && (
                            <h3 className="parkpass-section-heading h6">{title}</h3>
                        )}
                        {paragraphs.map((html, n) => (
                            <DisplayHtmlContent
                                key={`html-${n}`}
                                html={`<p>${html}</p>`}
                            />
                        ))}
                    </section>
                ))}

                <NoFeePeriods siteName={siteName} noFeePeriods={noFeePeriods} />
            </NeedToKnowSarsaparilla>
        );
    }
}

// cspell:ignore parkpass
